import type { Type } from '@angular/core';

export const TOASTER_STATUS = {
    SUCCESS: 'success',
    ERROR: 'error',
    INFO: 'info',
} as const;

export type ToasterStatus = (typeof TOASTER_STATUS)[keyof typeof TOASTER_STATUS];

export interface ToastAction {
    label: string;
    run: () => void;
}

export interface ToastContent {
    status: ToasterStatus;
    title: string;
    subtitle?: string;
    message?: string;
    action?: ToastAction;
    onClick?: () => void;
    component?: Type<unknown>;
    componentInputs?: Record<string, unknown>;
}
